import { DEFAULT_CANDIDATE } from '~/consts/candidates';
import { getStore } from '~/mobx/AppStore';
import { DEFAULT_CANDIDATE_PHOTO } from '../CandidateStore';

const onCreateCandidate = () => {
    const candidateStore = getStore().candidateStore;

    // Set create mode and initialize with default candidate
    candidateStore.setIsCreateMode(true);
    candidateStore.setSelectedCandidateEdit({ ...DEFAULT_CANDIDATE });
    candidateStore.setSelectedCandidateId(DEFAULT_CANDIDATE.id);
    candidateStore.getCandidateAttributeOptions();

    // Reset any previous state
    candidateStore.setIsEditMode(false);
    candidateStore.setFieldsKeyWithIssues([]);
    candidateStore.setPreviewCandidatePhoto(null);
    candidateStore.setCandidatePhoto(DEFAULT_CANDIDATE_PHOTO);
    candidateStore.setSelectedCandidateMemo();
};

export default onCreateCandidate;
